import { render, staticRenderFns } from "./TaskChat.vue?vue&type=template&id=7ae0da12&"
import script from "./TaskChat.vue?vue&type=script&lang=js&"
export * from "./TaskChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskChat.vue?vue&type=style&index=0&id=7ae0da12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports